import { getDatasetAtEvent } from "react-chartjs-2";
import Input from "../../components/custom/forms/Input";
import InputSearchMini from "../../components/custom/forms/InputSearchMini";
import Eventos from "./modals/Eventos";
import { obtenerFechasExtremas } from "../../../utils/CuponUtils";

const Cupon = ({
  data,
  setData,
  onChange,
  onClick,
  navigate,
  user,
  search,
  eventos,
  modalEventos,
  setModalEventos,
  dias,
  fechas,
  setFechas,
  salas,
}) => {
  const { fechaAnterior, fechaSiguiente } = obtenerFechasExtremas(
    data.fechas_funciones
  );

  console.log(fechaAnterior);

  return (
    <div
      className="container-md card px-3 py-5"
      style={{ maxWidth: "1000px", borderRadius: "10px" }}
    >
      <div className="row">
        <div className="col-md-12">
          <h2 className="me-2">
            {data.id ? `CUPON #${data.id}` : "NUEVO CUPON"}
          </h2>

          <label className="btn btn-primary fw-normal GothamBold text-white px-4 ">
            {`${data.id ? "Aplicar cambios" : "Guardar"}`}
            <button
              className="d-none"
              name={`${data.id ? "aplicar" : "guardar"}`}
              onClick={(event) => onClick(event)}
            ></button>
          </label>
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Nombre"}
            name={"nombre"}
            type={"text"}
            value={data?.nombre}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Codigo"}
            name={"codigo"}
            type={"text"}
            value={data?.codigo}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Descuento"}
            name={"descuento"}
            type={"number"}
            value={data?.descuento}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Limite"}
            name={"limite"}
            type={"number"}
            value={data?.limite}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Fecha de habilitación"}
            name={"fecha_habilitacion"}
            type={"date"}
            value={data?.fecha_habilitacion}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Fecha de expiracion"}
            name={"fecha_expiracion"}
            type={"date"}
            value={data?.fecha_expiracion}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-12 mb-3">
          <label className="form-label text-muted d-block">
            Tipo de aplicación
          </label>
          <select
            className="form-control border"
            name="tipo_aplicacion"
            id=""
            onChange={(e) => onChange(e)}
          >
            <option selected>{data?.tipo_aplicacion}</option>
            <option value={"eventos"}>Evento</option>
            <option value={"salas"}>Sala</option>
          </select>
        </div>

        {data?.tipo_aplicacion == "salas" ? (
          <div className="col-md-12">
            <div>
              <InputSearchMini
                onChange={onChange}
                label={"Busca una sala"}
                name={"search-sala"}
                type={"text"}
                value={search}
                //Autocomplete
                onClick={onClick}
                nameAutocomplete="añadir-sala"
                valueAutocomplete={salas}
                showIndex="nombre"
                sendIndex="id"
                validate={{}}
              />
              <label className="btn bg-trasnparent text-dark">
                Ver todos las salas disponibles
                <i class="bi bi-plus-lg ms-2"></i>
              </label>
            </div>
            <ul class="row">
              {data.salas
                ? data?.salas.map((sala, index) => {
                    return (
                      <li className="col-auto mb-2 list-group-item p-0 m-0 me-2">
                        <label className="btn btn-outline-dark border-0">
                          {sala.nombre}
                          <i class="ms-1 bi bi-x-lg"></i>
                          <button
                            className="d-none"
                            name="quitar-sala"
                            onClick={(e) => onClick(e, index)}
                          ></button>
                        </label>
                      </li>
                    );
                  })
                : ""}
            </ul>
          </div>
        ) : (
          ""
        )}

        {data?.tipo_aplicacion == "eventos" ? (
          <div className="col-md-12">
            <div>
              <InputSearchMini
                onChange={onChange}
                label={"Busca un evento especifico"}
                name={"search"}
                type={"text"}
                value={search}
                //Autocomplete
                onClick={onClick}
                nameAutocomplete="añadir-evento"
                valueAutocomplete={eventos}
                showIndex="nombre"
                sendIndex="id"
                validate={{}}
              />
              <label className="btn bg-trasnparent text-dark">
                Ver todos los eventos disponibles
                <i class="bi bi-plus-lg ms-2"></i>
                <button
                  name="ver-eventos"
                  className="d-none"
                  onClick={(e) => onClick(e)}
                ></button>
              </label>
            </div>
            <ul class="row">
              {
              data?.eventos ?
              data?.eventos.map((evento, index) => {
                return (
                  <li className="col-auto mb-2 list-group-item p-0 m-0 me-2">
                    <label className="btn btn-outline-dark border-0">
                      {evento.nombre}
                      <i class="ms-1 bi bi-x-lg"></i>
                      <button
                        className="d-none"
                        name="quitar-evento"
                        onClick={(e) => onClick(e, index)}
                      ></button>
                    </label>
                  </li>
                );
              }) : ""}
            </ul>
          </div>
        ) : (
          ""
        )}

        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Fecha de inicio"}
            name={"fecha_inicio"}
            type={"date"}
            value={fechas.fecha_inicio ?? fechaAnterior}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-6">
          <Input
            onChange={onChange}
            label={"Fecha de fin"}
            name={"fecha_fin"}
            type={"date"}
            value={fechas.fecha_fin ?? fechaSiguiente}
            validate={{}}
            disabled={false}
          />
        </div>
        <div className="col-md-12 mb-2">
          {dias.map((dia) => {
            return (
              <label
                className={`btn btn-outline-dark me-1 mb-1 ${
                  fechas.dias.includes(dia.value) ? "active" : ""
                }`}
              >
                {dia.name}
                <button
                  className="d-none"
                  name="dia"
                  onClick={(e) => onClick(e, dia)}
                ></button>
              </label>
            );
          })}
        </div>
        <div className="col-md-12">
          <ul class="row">
            {data?.fechas_funciones.map((fechas, index) => {
              return (
                <li className="col-auto mb-2 list-group-item p-0 m-0 me-2">
                  <label className="btn btn-outline-dark border-0">
                    {fechas.fechas[0]}
                    <i class="ms-1 bi bi-x-lg"></i>
                    <button
                      className="d-none"
                      name="quitar-fecha"
                      onClick={(e) => onClick(e, index)}
                    ></button>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {modalEventos ? (
        <Eventos setCupon={setData} cupon={data} setModal={setModalEventos} />
      ) : (
        ""
      )}
    </div>
  );
};

export default Cupon;
